import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SummaryViewPage } from "src/components/views/spc/summaryViews/SummaryViewPage.tsx";
import { SummaryViewApi } from "src/api/generated/spc/summaryViews/summaryViewApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/spc/summaryViews/diagram/$summaryViewId")({
	staticData: {
		legacyViewKey: "diagramSummaryViewsPages",
		listGeneratedViews: async () =>
			(await SummaryViewApi.getPermittedSummaryViews())
				.filter((summaryView) => summaryView.summaryViewType === "flowchart")
				.map((summaryView) => ({
					id: summaryView.id,
					title: summaryView.summaryViewName ?? i18n.t("summary_view"),
				})),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id },
		isActive,
	} = useKeptAliveGeneratedView();
	return <SummaryViewPage summaryViewId={id} isActive={isActive} />;
}
